var map = {
	"./anm-card.png": 1221,
	"./arrow.png": 1222,
	"./arrow.webp": 1223,
	"./asset-1.svg": 1224,
	"./bg-exclusive.webp": 1225,
	"./boost.svg": 1226,
	"./brand-logo-cny.png": 1227,
	"./brand-logo-raya.webp": 1228,
	"./brand-logo.png": 113,
	"./brand-logo.webp": 1229,
	"./btn-black-m.webp": 1230,
	"./btn-blue-m-v2.png": 1231,
	"./btn-blue-m.png": 1232,
	"./btn-blue-m.webp": 1233,
	"./btn-white-m-v2.png": 1234,
	"./btn-white-m.png": 1235,
	"./check-btn.webp": 1236,
	"./default-bg.webp": 1237,
	"./deposit.webp": 1238,
	"./drop-more-btn.webp": 1239,
	"./duitnow.svg": 1240,
	"./eeziepay.svg": 1241,
	"./fcl.svg": 1242,
	"./fcl.webp": 1243,
	"./fpx-logo.svg": 1244,
	"./game-blue.png": 1245,
	"./game-img.png": 1246,
	"./game-white.png": 1247,
	"./global-language.svg": 1248,
	"./grabpay.svg": 1249,
	"./ifm-logo.svg": 1250,
	"./ifm-logo.webp": 1251,
	"./modal-bg.jpg": 1252,
	"./number-bg.webp": 1253,
	"./pagcor.svg": 1254,
	"./pagcor.webp": 1255,
	"./pool-bg.webp": 1256,
	"./promo-given.webp": 1257,
	"./side-bar-bg.png": 1258,
	"./spotlight-base.svg": 1259,
	"./spotlight.svg": 1260,
	"./tether.svg": 1261,
	"./title-asset.svg": 1262,
	"./tng.svg": 1263,
	"./winner.webp": 1264,
	"./withdrawal.webp": 1265
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;